import cn from 'clsx'

// Components
import { Link, Section } from '@tracklib/kit'
import Cover from 'components/collection/cover'
import TrackList from 'components/browse/tracklist'

// Hooks
import { useCollections } from 'modules/entities/hooks'
import { useSearchQuery } from 'modules/browse/hooks'

import styles from './collectionblock.css'

type CollectionBlockProps = {
  value: {
    collection: number
    show_header: boolean
    compact: boolean
  }
}

const CollectionBlock = (props: CollectionBlockProps): JSX.Element | null => {
  const {
    value: { show_header: showHeader, compact, collection: collectionId },
  } = props

  const collection = useCollections()[String(collectionId)]
  const songListProps = useSearchQuery({ collection: String(collectionId) }, undefined, true)

  if (collection) {
    return (
      <Section size="small">
        <div className={cn(styles.wrapper, showHeader && styles.showHeader, showHeader && compact && styles.showHeaderCompact)}>
          {showHeader && (
            <Link to={`/collection/${collection.id}/`}>
              <header className={styles.header}>
                <Cover collection={collection} className={styles.cover} />
                <div>
                  <p className={styles.title}>{collection.title}</p>
                  <p className={styles.owner}>
                    by <span>{collection.owner_name}</span>
                  </p>
                  <p className={styles.description}>{collection.description}</p>
                </div>
              </header>
            </Link>
          )}

          <TrackList {...songListProps} hideRecommendations mode={compact ? 'compact' : undefined} />
        </div>
      </Section>
    )
  }
  return null
}

export default CollectionBlock
